var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("h2", [_vm._v(_vm._s(_vm.technicalSheetDto.title))]),
    ]),
    _vm._v(" "),
    _vm.technicalSheetDto.packContentDTO
      ? _c(
          "div",
          { staticClass: "col-12", attrs: { id: "anchor-technical-sheet" } },
          [
            _c("p", { staticClass: "lead mb-0" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.technicalSheetDto.packContentDTO.title)),
              ]),
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "mb-0",
              domProps: {
                innerHTML: _vm._s(_vm.technicalSheetDto.packContentDTO.text),
              },
            }),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "col-12 d-md-block" }, [
      _c(
        "div",
        { staticClass: "row" },
        _vm._l(
          _vm.characteristics,
          function (characteristicDto, characteristicIndex) {
            return _c(
              "div",
              { key: characteristicIndex, staticClass: "col-12 col-md-6 py-1" },
              [
                _c("p", { staticClass: "lead mb-0" }, [
                  _c("strong", [_vm._v(_vm._s(characteristicDto.title))]),
                ]),
                _vm._v(" "),
                _vm._l(
                  characteristicDto.characteristicsDetailsDTO,
                  function (characteristicDetailsDto, index) {
                    return _c("div", { key: index }, [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex",
                          class: { "bg-gray2": index % 2 !== 0 },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "col-6 characteristic__details" },
                            [
                              _c("span", [
                                _vm._v(_vm._s(characteristicDetailsDto.title)),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-6 characteristic__details" },
                            [
                              characteristicDetailsDto.link
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: characteristicDetailsDto.text,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(characteristicDetailsDto.text)
                                      ),
                                    ]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(characteristicDetailsDto.text)
                                    ),
                                  ]),
                            ]
                          ),
                        ]
                      ),
                    ])
                  }
                ),
              ],
              2
            )
          }
        ),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }